const DownloadAll = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 33.733 33.733"
  >
    <g
      id="Group_1750"
      data-name="Group 1750"
      transform="translate(-1647.133 -121.133)"
    >
      <path
        id="Path_1685"
        data-name="Path 1685"
        d="M33.149,4.47C30.679,2,26.7,2,18.753,2S6.826,2,4.356,4.47C3.079,5.748,2.462,7.428,2.164,9.853A10.963,10.963,0,0,1,5.342,7.412,11.221,11.221,0,0,1,9.634,6.34c1.51-.123,3.368-.123,5.639-.123h6.959c2.272,0,4.129,0,5.639.123a11.219,11.219,0,0,1,4.292,1.072,10.962,10.962,0,0,1,3.178,2.441c-.3-2.425-.915-4.105-2.192-5.383Z"
        transform="translate(1645.246 119.133)"
        fill="inherit"
      />
      <path
        id="Path_1686"
        data-name="Path 1686"
        d="M2,19.493c0-4.723,0-7.085.919-8.889A8.433,8.433,0,0,1,6.6,6.919C8.409,6,10.77,6,15.493,6H22.24c4.723,0,7.085,0,8.889.919A8.432,8.432,0,0,1,34.814,10.6c.919,1.8.919,4.165.919,8.889s0,7.085-.919,8.889a8.432,8.432,0,0,1-3.685,3.685c-1.8.919-4.166.919-8.889.919H15.493c-4.723,0-7.085,0-8.889-.919a8.433,8.433,0,0,1-3.686-3.685C2,26.578,2,24.217,2,19.493Zm17.761,5.954a1.265,1.265,0,0,1-1.789,0l-4.217-4.217a1.265,1.265,0,0,1,1.789-1.789L17.6,21.5V14.433a1.265,1.265,0,0,1,2.53,0V21.5l2.057-2.057a1.265,1.265,0,0,1,1.789,1.789Z"
        transform="translate(1645.133 121.88)"
        fill="inherit"
        fill-rule="evenodd"
      />
    </g>
  </svg>
);

export default DownloadAll;
